import createExtend from '@C/createExtend';
import rejectDialog from './rejectDialog';

const creator = () => {
  return new Promise((resolve, reject) => {
    const Dialog = createExtend(rejectDialog);
    Dialog.$on('confirm', function(remark) {
      Dialog.remove();
      resolve(remark);
    });
    Dialog.$on('close', () => {
      Dialog.remove();
      reject();
    });
  });
};
export default creator;
